import { APP_TOOLTIPS } from "../../../../../../src/texts/tooltips";

const loadingParams = [
  { 
    key: 'Nz', 
    title: 'Nz',
    tooltip: APP_TOOLTIPS.TOOLTIP_TENSILE_FORCE_VALUE, 
    animationName: 'z', 
    action: 'move'
   },
  { 
    key: 'Vx', 
    title: 'Vx', 
    tooltip:APP_TOOLTIPS.TOOLTIP_SHEAR_FORCE_X_DIRECTION,
    animationName: 'x', 
    action: 'move'
   },

  { 
    key: 'Vy', 
    title: 'Vy',
    tooltip:APP_TOOLTIPS.TOOLTIP_SHEAR_FORCE_Y_DIRECTION, 
    animationName: 'y', 
    action: 'move' 
  },
  {
     key: 'Mz', 
     title: 'Mz', 
     tooltip:APP_TOOLTIPS.TOOLTIP_TORSIONAL_MOMENT_Z_AXIS,
     animationName: 'z', 
     action: 'rotate' 
  },
  { 
    key: 'Mx', 
    title: 'Mx', 
    tooltip:APP_TOOLTIPS.TOOLTIP_BENDING_MOMENT_X_AXIS,
    animationName: 'x', 
    action: 'rotate' 
  },
  {
     key: 'My', 
     title: 'My', 
     tooltip:APP_TOOLTIPS.TOOLTIP_BENDING_MOMENT_Y_AXIS,
     animationName: 'y', 
     action: 'rotate' 
  }
];

export default loadingParams;



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/misc/loadingParams.js